// test2099
(2099 && 0);
